import { useIntl } from "react-intl";

import Page from "../../components/Page"
import Banner from "../../components/banner";

const Reviews = () => {
    const intl = useIntl();

    const items = [
        'Շնորհակալություն եմ հայտնում բարձրակարգ սպասարկման համար։',
        'Ուղղակի որակյալ ու հրաշք գործեր:',
        'Refunds are made to the account from which payment was made.',
        'Գնել ենք 2 ժամացույց `որակյալ և գեղեցիկ։Շնորհակալ ենք բարեխիղճ վերաբերմունքի և լավ սպասարկմամ համր։',
        'Շնորհակալ եմ լավ սպասարկման և բոլոր հարցերիս ՀԱՄԲԵՐԱՏԱՐ պատասխանելու համար...',
        'Շնորհակալ ենք լավ, համբերատար և արագ սպասարկման համար։Միանշանակ բարձրակարգ մասնագետների ձեռքի գործեր են։',
        'Պարզապես հիանալի աշխատանք, անպայման նորից կօգտվենք:',
        'Thank you for quilty items.',
        'I am satisfied with both the quality of the product and the service.',
        'Купила в подарок, и она мне настолько понравилась, что я купила и себе.',
        'Просто роскошь, это чудесный подарок.',
    ];

    return (
        <Page meta={{
            title: 'Կարծիքներ | Handle Brand',
            description: 'Պատվիրեք անվանական շախմատները և նարդիները, փայտե ժամացույցները, խաղաքարերը, տակառները և հուշանվերները Handle.am - ից'
        }}>
            <div className="about">
                <Banner
                    title={intl.messages.reviews}
                    currentPage={intl.messages.reviews}
                />
                <div className="wrapper">
                    <div className="about-box">
                        <div className="card card-body">
                            {items.map((item, index) => (
                                <div key={index}>
                                    <p style={{ borderBottom: '1px solid', paddingBottom: '10px' }}>{item}</p>
                                    <p><br /></p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </Page>
    )
}

export default Reviews